/* For Card Customization Reducer */
export const RECEIVE_CUSTOMIZATION = 'zola/cards/card_customization/RECEIVE_CUSTOMIZATION';
export const RECEIVE_RSVP_CARDS_DISABLED = 'zola/cards/card_customization/RECEIVE_RSVP_CARDS_DISABLED';
export const ADD_CUSTOM_PHOTO = 'zola/cards/card_customization/ADD_CUSTOM_PHOTO';
export const REQUEST_UPDATE_CUSTOMIZATION = 'zola/cards/card_customization/REQUEST_UPDATE_CUSTOMIZATION';
export const SET_FOOTER_LABEL = 'zola/cards/card_customization/SET_FOOTER_LABEL';
export const RECEIVE_FIELD_WIDTH_ERROR = 'zola/cards/card_customization/RECEIVE_FIELD_WIDTH_ERROR';
export const REMOVE_FIELD_WIDTH_ERROR = 'zola/cards/card_customization/REMOVE_FIELD_WIDTH_ERROR';
export const SET_SILHOUETTE = 'zola/cards/card_customization/SET_SILHOUETTE';
export const SET_ACTIVE_FIELD = 'zola/cards/card_customization/SET_ACTIVE_FIELD';

/* For Project Reducer */
export const SET_PROJECT_UUID = 'zola/cards/project/SET_PROJECT_UUID';
export const SAVE_PROJECT_SUCCESS = 'zola/cards/project/SAVE_PROJECT_SUCCESS';
export const CLOSE_CUSTOM = 'zola/cards/project/CLOSE_CUSTOM';
export const SET_BREADCRUMS = 'zola/cards/project/SET_BREADCRUMS';
export const SET_PRODUCT_ID = 'zola/cards/project/SET_PRODUCT_ID';
export const SET_SKU_ID = 'zola/cards/project/SET_SKU_ID';
export const SET_CUSTOMIZATION_UUID = 'zola/cards/project/SET_CUSTOMIZATION_UUID';
export const RECEIVE_PROJECT_ORDER_VIEW = 'zola/cards/project/RECEIVE_PROJECT_ORDER_VIEW';
export const SET_PROJECT_PAGES = 'zola/cards/project/SET_PROJECT_PAGES';
export const SET_COMPLETED_MENU = 'zola/cards/project/SET_COMPLETED_MENU';
export const SELECT_QUANTITY = 'zola/cards/project/SELECT_QUANTITY';
export const SELECT_SIZE = 'zola/cards/project/SELECT_SIZE';
export const SET_PROJECT_TYPE = 'zola/cards/project/SET_PROJECT_TYPE';
export const RECEIVE_PROJECT = 'zola/cards/project/RECEIVE_PROJECT';
export const SET_CURRENT_STEP = 'zola/cards/project/SET_CURRENT_STEP';

/* For Customize Reducer */
// export const PRE_FILL_RENDER_CARDS = 'zola/cards/customize/PRE_FILL_RENDER_CARDS';
// export const PRE_FILL_FRONT_BACK = 'zola/cards/customize/PRE_FILL_FRONT_BACK';
// export const PRE_FILL_RSVP = 'zola/cards/customize/PRE_FILL_RSVP';
// export const PRE_FILL_RSVP_ENVELOPE = 'zola/cards/customize/PRE_FILL_RSVP_ENVELOPE';
// export const PRE_FILL_ENVELOPE = 'zola/cards/customize/PRE_FILL_ENVELOPE';
// export const PRE_FILL_RECIPIENT = 'zola/cards/customize/PRE_FILL_RECIPIENT';
// export const PRE_FILL_DETAIL = 'zola/cards/customize/PRE_FILL_DETAIL';
// export const UPDATE_CARD_TEXT_BY_NAME = 'zola/cards/customize/UPDATE_CARD_TEXT_BY_NAME';
// export const SAVE_AND_CONTINUE = 'zola/cards/customize/SAVE_AND_CONTINUE';
// export const UPDATE_ACTIVE_PAGE_NAME = 'zola/cards/render/UPDATE_ACTIVE_PAGE_NAME';
// export const SET_HIGH_LIGHT_IDX = 'zola/cards/render/SET_HIGH_LIGHT_IDX';
// export const DELETE_CUSTOM_PHOTO = 'zola/cards/render/DELETE_CUSTOM_PHOTO';
// export const ADD_HIDE_IMG = 'zola/cards/render/ADD_HIDE_IMG';
// export const REMOVE_HIDE_IMG = 'zola/cards/render/REMOVE_HIDE_IMG';

/* For ControlPanel Reducer*/
// export const PRE_FILL_CONTROL_PANEL = 'zola/cards/controlPanel/PRE_FILL_CONTROL_PANEL';
// export const LOAD_MENU = 'zola/cards/controlPanel/LOAD_MENU';
// export const SET_NEXT_MENU_ITEM = 'zola/cards/controlPanel/SET_NEXT_MENU_ITEM';
// export const SET_ACTIVE_MENU_ITEM = 'zola/cards/controlPanel/SET_ACTIVE_MENU_ITEM';
// export const SET_PREV_MENU_ITEM = 'zola/cards/controlPanel/SET_PREV_MENU_ITEM';
// export const SET_PAPER_OPTIONS = 'zola/cards/controlPanel/SET_PAPER_OPTIONS';
// export const GET_MEAL_SUCCESS = 'zola/cards/controlPanel/GET_MEAL_SUCCESS';

/* For User Select Reducer */
/* Shared */
// export const UPDATE_ACTIVE_TAB_NAME = 'zola/cards/userSelect/UPDATE_ACTIVE_TAB_NAME';
// export const UPDATE_CONTROL_TEXT_BY_NAME = 'zola/cards/userSelect/UPDATE_CONTROL_TEXT_BY_NAME';
// export const TOGGLE_ENVELOPE_RETURN_ADDRESS = 'zola/cards/userSelect/TOGGLE_ENVELOPE_RETURN_ADDRESS';

/* Design */
// export const UPDATE_PAPER_QTY = 'zola/cards/userSelect/UPDATE_PAPER_QTY';
// export const UPDATE_PAPER_TYPE = 'zola/cards/userSelect/UPDATE_PAPER_TYPE';
// export const UPDATE_SHAPE_SELECT = 'zola/cards/userSelect/UPDATE_SHAPE_SELECT';


/* BACK */
// export const TOGGLE_CUSTOMIZE_BACK_SUCCESS = 'zola/cards/userSelect/TOGGLE_CUSTOMIZE_BACK_SUCCESS';

/* Half Detail*/
// export const SET_MANDRIL_TEXT_BY_NAME = 'zola/cards/userSelect/SET_MANDRIL_TEXT_BY_NAME';
// export const UPDATE_LINK_TYPE = 'zola/cards/userSelect/UPDATE_LINK_TYPE';

/* Envelope */
// export const CHANGE_LINER = 'zola/cards/userSelect/CHANGE_LINER';

/* RSVP */
// export const TOGGLE_ADD_RSVP_SUCCESS = 'zola/cards/userSelect/TOGGLE_ADD_RSVP_SUCCESS';
// export const TOGGLE_ADD_MEAL = 'zola/cards/userSelect/TOGGLE_ADD_MEAL';

/* RSVP Envelope */
// export const TOGGLE_RETURN_ADDRESS_SUCCESS = 'zola/cards/userSelect/TOGGLE_RETURN_ADDRESS_SUCCESS';

/* Recipient */
// export const TOGGLE_RECIPIENT_ADDRESS = 'zola/cards/userSelect/TOGGLE_RECIPIENT_ADDRESS';

/* Guest */
// export const SELECT_GUEST_GROUP_TYPE = 'zola/cards/userSelect/SELECT_GUEST_GROUP_TYPE';
// export const CREATE_GUEST = 'zola/cards/userSelect/CREATE_GUEST';

/* For Modal Reducer */
export const OPEN_MODAL = 'zola/cards/modal/OPEN_MODAL';
export const HIDE_MODAL = 'zola/cards/modal/HIDE_MODAL';
export const FLIP_FORMAT_FLAG = 'zola/cards/modal/FLIP_FORMAT_FLAG';
export const IS_BUSY = 'zola/cards/modal/IS_BUSY';

/* For Entities Reducer */
// export const ENTITY_DELETE = 'zola/cards/entity/ENTITY_DELETE';
// export const ENTITY_DELETED = 'zola/cards/entity/ENTITY_DELETED';
// export const ENTITY_REQUESTED = 'zola/cards/entity/ENTITY_REQUESTED';
// export const ENTITY_ADD = 'zola/cards/entity/ENTITY_ADD';
// export const ENTITY_RECEIVED = 'zola/cards/entity/ENTITY_RECEIVED';
// export const ENTITY_SELECTED = 'zola/cards/entity/ENTITY_SELECTED';
// export const ENTITY_CREATED = 'zola/cards/entity/ENTITY_CREATED';
// export const ENTITIES_REQUESTED = 'zola/cards/entity/ENTITIES_REQUESTED';
// export const ENTITIES_RECEIVED = 'zola/cards/entity/ENTITIES_RECEIVED';
// export const ENTITIES_RESET = 'zola/cards/entity/ENTITIES_RESET';
// export const ENTITY_SHOW_FILE_PREVIEW = 'zola/cards/entity/ENTITY_SHOW_FILE_PREVIEW';

/* For File Reducer */
export const FILE_UPLOADING = 'zola/cards/file/FILE_UPLOADING';
export const FILE_UPLOADED = 'zola/cards/file/FILE_UPLOADED';
export const FILE_TEMP_UPLOADED = 'zola/cards/file/FILE_TEMP_UPLOADED';
export const FILE_CROPPED = 'zola/cards/file/FILE_CROPPED';
export const STORE_REFERENCE_KEY = 'zola/cards/file/STORE_REFERENCE_KEY';
export const SHOW_REJECTION_PHOTO_MODAL = 'zola/cards/file/SHOW_REJECTION_PHOTO_MODAL';
export const UPLOAD_INTERRUPTED = 'zola/cards/file/UPLOAD_INTERRUPTED';

/*  For Notification @TODO */
export const SHOW_NOTIFICATION = 'zola/cards/notifications/SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'zola/cards/notifications/HIDE_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'zola/cards/notifications/CLEAR_NOTIFICATIONS';

/* For Checkout cards */
export const REQUEST_DRAFTS = 'zola/cards/checkout/REQUEST_DRAFTS';
export const RECEIVE_DRAFTS = 'zola/cards/checkout/RECEIVE_DRAFTS';
export const REQUEST_COMPLETED = 'zola/cards/checkout/REQUEST_COMPLETED';
export const RECEIVE_COMPLETED = 'zola/cards/checkout/RECEIVE_COMPLETED';
export const RECEIVE_CANCELED_ORDER = 'zola/cards/checkout/RECEIVE_CANCELED_ORDER';

/* For Product Listing Reducer */
export const REQUEST_CARDS = 'zola/cards/plp/REQUEST_CARDS';
export const RECEIVE_CARDS = 'zola/cards/plp/RECEIVE_CARDS';
export const REQUEST_MORE_CARDS = 'zola/cards/plp/REQUEST_MORE_CARDS';
export const RECEIVE_MORE_CARDS = 'zola/cards/plp/RECEIVE_MORE_CARDS';
export const LISTING_CARD_LOAD_MORE = 'zola/cards/plp/LISTING_CARD_LOAD_MORE';
export const LISTING_CARD_ACTIVE_CHANGE = 'zola/cards/plp/LISTING_CARD_ACTIVE_CHANGE';
export const LISTING_CARD_TYPE_CHANGE = 'zola/cards/plp/LISTING_CARD_TYPE_CHANGE';
export const LISTING_CARD_COLORS_CHANGE = 'zola/cards/plp/LISTING_CARD_COLORS_CHANGE';
export const LISTING_CARD_BOOLEAN_FILTER_CHANGE = 'zola/cards/plp/LISTING_CARD_BOOLEAN_FILTER_CHANGE';
export const LISTING_RESET_FILTERS = 'zola/cards/plp/LISTING_RESET_FILTERS';
export const LISTING_CARD_DETAIL_SKU_CHANGE = 'zola/cards/plp/LISTING_CARD_DETAIL_SKU_CHANGE';
export const LISTING_ADMIN_VIEW = 'zola/cards/plp/LISTING_ADMIN_VIEW';

/* For Product Detail Reducer */
export const RENDER_DETAIL = 'zola/cards/pdp/RENDER_DETAIL';
export const SELECT_EVENT_TYPE = 'zola/cards/pdp/SELECT_EVENT_TYPE';
export const SELECT_FORM_TYPE = 'zola/cards/pdp/SELECT_FORM_TYPE';
export const SELECT_WRAP_TYPE = 'zola/cards/pdp/SELECT_WRAP_TYPE';
export const SELECT_PRODUCT_COLOR = 'zola/cards/pdp/SELECT_PRODUCT_COLOR';
export const DETAIL_ADMIN_VIEW = 'zola/cards/plp/DETAIL_ADMIN_VIEW';

/* Invitation Account actions */
export const CREATE_INVITATION_ACCOUNT = 'zola/cards/invitation_account/create';
export const REQUEST_INVITATION_ACCOUNT = 'zola/cards/invitation_account/request';
export const RECEIVE_INVITATION_ACCOUNT = 'zola/cards/invitation_account/receive';

/* For Project Authentication Check */
export const RECEIVE_PROJECT_AUTHENTICATION = 'zola/cards/project/RECEIVE_PROJECT_AUTHENTICATION';
export const REQUEST_PROJECT_AUTHENTICATION = 'zola/cards/project/REQUEST_PROJECT_AUTHENTICATION';

/* For Recipients - not sure yet what reducer will use this */
export const REQUEST_PROJECT_GUEST_IDS = 'zola/cards/project/guests/REQUEST_PROJECT_GUEST_IDS';
export const RECEIVE_PROJECT_GUEST_IDS = 'zola/cards/project/guests/RECEIVE_PROJECT_GUEST_IDS';
export const RESET_SELECTED_GUEST_IDS = 'zola/cards/project/guests/RESET_SELECTED_GUEST_IDS';



/** WEBPACK FOOTER **
 ** ./src/cards/actions/constants.js
 **/